// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"34a68fd1","732":"eafb77f3","977":"5bb3c647"}[chunkId] + ".chunk.js";
};